import React, { useRef } from 'react';
import './GoogleHome.css';
import GoogleLogo from './GoogleLogo';

export default function GoogleHome({ query, setQuery, onSearch }) {
  const inputRef = useRef(null);

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') onSearch(query);
  };

  return (
    <div className="home-container">
      {/* Top nav – タブ行 */}
      <div className="home-top-nav">
        <div className="home-nav-left">
          <svg className="home-nav-icon" viewBox="0 0 24 24"><path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"/></svg>
          <span className="home-nav-tab home-nav-tab-active">すべて</span>
          <span className="home-nav-tab">画像</span>
        </div>
        <div className="home-nav-right">
          <svg className="home-nav-icon" viewBox="0 0 24 24"><path d="M12 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z"/></svg>
          <svg className="home-nav-icon home-nav-grid" viewBox="0 0 24 24"><path d="M6 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 4c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12-12c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 4c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6-20c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"/></svg>
          <div className="home-nav-avatar">S</div>
        </div>
      </div>

      <div className="home-body">
        <div className="home-logo-wrap">
          <GoogleLogo height={71} />
        </div>

        <div className="home-search-wrap">
          <div className="home-search-box" onClick={() => inputRef.current?.focus()}>
            <svg className="home-search-icon" viewBox="0 0 24 24">
              <path d="M20.49 19l-5.73-5.73C15.53 12.2 16 10.91 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.41 0 2.7-.47 3.77-1.24L19 20.49 20.49 19zM5 9.5C5 7.01 7.01 5 9.5 5S14 7.01 14 9.5 11.99 14 9.5 14 5 11.99 5 9.5z"/>
            </svg>
            <input
              ref={inputRef}
              className="home-search-input"
              type="text"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              onKeyDown={handleKeyDown}
              placeholder="Google で検索するか URL を入力"
              autoComplete="off"
              autoCorrect="off"
              spellCheck="false"
            />
            <div className="home-search-right-icons">
              {query && (
                <button className="home-icon-btn" onClick={() => setQuery('')}>
                  <svg viewBox="0 0 24 24"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/></svg>
                </button>
              )}
              {/* AI Overviews icon */}
              <button className="home-icon-btn">
                <svg viewBox="0 0 24 24" className="home-ai-icon">
                  <path d="M12 2L9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2z"/>
                </svg>
              </button>
              <button className="home-icon-btn">
                <svg viewBox="0 0 24 24" className="home-mic-icon">
                  <path d="M12 15c1.66 0 3-1.34 3-3V6c0-1.66-1.34-3-3-3S9 4.34 9 6v6c0 1.66 1.34 3 3 3zm-1-9c0-.55.45-1 1-1s1 .45 1 1v6c0 .55-.45 1-1 1s-1-.45-1-1V6zm6 6c0 2.76-2.24 5-5 5s-5-2.24-5-5H5c0 3.53 2.61 6.43 6 6.92V21h2v-2.08c3.39-.49 6-3.39 6-6.92h-2z"/>
                </svg>
              </button>
              <button className="home-icon-btn">
                <svg viewBox="0 0 24 24" className="home-camera-icon">
                  <path d="M12 15.2c-1.77 0-3.2-1.43-3.2-3.2s1.43-3.2 3.2-3.2 3.2 1.43 3.2 3.2-1.43 3.2-3.2 3.2zM9 2L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-3.17L15 2H9zm3 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z"/>
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="home-footer">
        <div className="footer-region">日本</div>
        <div className="footer-links-row">
          <a href="#!">広告</a>
          <a href="#!">ビジネス</a>
          <a href="#!">検索の仕組み</a>
        </div>
        <div className="footer-divider" />
        <div className="footer-links-row">
          <a href="#!">プライバシー</a>
          <a href="#!">規約</a>
          <a href="#!">設定</a>
        </div>
      </div>
    </div>
  );
}
